<template>
  <div class="">

    <Head />


    <div class="main shiftSchedule">
      <AccesskeyLink target="accesskey_c" accesskey="c" aria-label="跳到中央內容區塊">
        :::
      </AccesskeyLink>

      <!-- 毛毛蟲 -->
      <nav aria-label="breadcrumb" class="breadcrumb_box">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="#" :title="$t('首頁')">{{ $t('首頁') }}</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('管理員工班表') }}</li>
          </ol>
        </div>
      </nav>


      <div class="shiftSchedule_box">

        <div class="container">

          <div class="title_box">
            <h2>{{ scheduleName || $t('管理員工班表') }}</h2>
            <p class="text-muted mt-2">{{ $t('管理者模式') }}</p>
            <div v-if="scheduleOpenStatus === 'notOpen'" class="schedule_status_notice notice_warning">
              {{ $t('未開放排班') }}
            </div>
            <div v-else-if="scheduleOpenStatus === 'closed'" class="schedule_status_notice notice_closed">
              {{ $t('排班已截止') }}
            </div>
          </div>


          <div class="schedule">


            <!-- 圖示說明 -->
            <ul class="iconItems_box">
              <li v-for="(item, index) in iconItems" :key="index">
                <img :src="item.src" :alt="item.title">
                <p>{{ item.title }}</p>
              </li>
            </ul>

            <!-- 排班表 -->
            <div class="schedule_fixed">

              <!-- 左側固定姓名欄 -->
              <div class="name_wrapper">
                <table class="name_table">
                  <thead>
                    <tr>
                      <th class="name">
                        {{ $t('員工姓名') }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="user in users" :key="user.csvId">
                      <td class="name">
                        <div class="group">
                          <p>{{ user.name }}</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>

              <!-- 右側日期表格 -->
              <div class="date_wrapper">
                <table class="schedule_table">
                  <thead>
                    <tr>
                      <th v-for="day in daysInPeriod" :key="day.dateStr" :class="day.isHoliday ? 'holiday' : 'weekday'">
                        <div class="day_box">
                          <div>{{ day.day }}</div>
                          <div class="week">（{{ day.weekday }}）</div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="user in users" :key="user.csvId">
                      <td v-for="day in daysInPeriod" :key="day.dateStr" class="date"
                        :class="day.isHoliday ? 'holiday' : 'weekday'">
                        <div class="date_box">
                          <button class="date_btn" :class="{ active: isActive(user.csvId, day.dateStr), 'date_btn_no_edit': scheduleOpenStatus !== 'open' }"
                            @click.stop="openPicker(user.csvId, day.dateStr, $event)">
                            <img v-if="getShiftImg(user.csvId, day.dateStr)"
                              :src="getShiftImg(user.csvId, day.dateStr)" />
                            <img v-else src="img/workdays_green.svg" alt="可上班日">
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- 班別選擇 Picker -->
              <div v-if="picker.visible" class="shift_picker"
                :style="{ top: picker.y + 'px', left: picker.x + 'px' }">
                <div v-for="opt in shiftOptions" :key="opt.id" class="option" @click="selectShift(opt.id)">
                  <img :src="opt.img" />
                  <div>{{ opt.text }}</div>
                </div>
              </div>

            </div>

            <div class="text_box">
              <p>
                {{ $t('注意事項') }}
                <br>
                {{ $t('管理者模式：可不受時間限制調整所有員工的排班') }}
                <br>
                {{ $t('*如遇天然災害，依本市公佈放假標準為原則。') }}
              </p>
            </div>

            <div class="btn_box">
              <button class="send_btn" @click="saveSchedule" :disabled="scheduleOpenStatus !== 'open'">{{ $t('儲存') }}</button>
            </div>

          </div>




        </div>


      </div>

    </div>

    <Footer />

  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Footer from '@/components/Footer.vue';
import Swal from 'sweetalert2';

import AccesskeyLink from '@/views/AccesskeyLink.vue'



export default {

  name: 'ShiftScheduleManager',
  components: {
    Head,
    Footer,

    AccesskeyLink,

  },

  data() {
    return {

      iconItems: [
        {
          src: require('/public/img/workdays_green.svg'),
          title: '可上班日',
        },
        {
          src: require('/public/img/restDay_bule.svg'),
          title: '休息日(可加班)',
        },
        {
          src: require('/public/img/regularDayOff_red.svg'),
          title: '例假日(不可加班)',
        },
        {
          src: require('/public/img/star-svgrepo-com.svg'),
          title: '特休',
        },
      ],

      scheduleName: '',
      csId: 0,
      token: '',
      managerMId: 0,
      startDate: null,
      endDate: null,
      minRestDays: 0,
      minRegularDaysOff: 0,
      openSchedulingStartTime: null,
      openSchedulingEndTime: null,

      users: [],

      shiftOptions: [
        {
          id: 'workday',
          text: '可上班日',
          img: require('/public/img/workdays_green.svg'),
        },
        {
          id: 'restDay',
          text: '休息日(可加班)',
          img: require('/public/img/restDay_bule.svg'),
        },
        {
          id: 'regularDayOff',
          text: '例假日(不可加班)',
          img: require('/public/img/regularDayOff_red.svg'),
        },
        {
          id: 'specialLeave',
          text: '特休',
          img: require('/public/img/star-svgrepo-com.svg'),
        }
      ],

      // 排班記錄 格式: { 'csvId_date': 'shiftType' }
      schedules: {},

      picker: {
        visible: false,
        userId: null,
        day: null,
        x: 0,
        y: 0
      },

      isActive(userId, day) {
        return (
          this.picker.visible &&
          this.picker.userId === userId &&
          this.picker.day === day
        )
      },


    }
  },

  async mounted() {
    // 設定iconItems翻譯
    this.iconItems = [
      {
        src: require('/public/img/workdays_green.svg'),
        title: this.$t('可上班日'),
      },
      {
        src: require('/public/img/restDay_bule.svg'),
        title: this.$t('休息日(可加班)'),
      },
      {
        src: require('/public/img/regularDayOff_red.svg'),
        title: this.$t('例假日(不可加班)'),
      },
      {
        src: require('/public/img/star-svgrepo-com.svg'),
        title: this.$t('特休'),
      },
    ]
    
    document.addEventListener('click', this.closePicker)

    // 從路由參數取得 csId、token 和 managerMId
    this.csId = parseInt(this.$route.params.csId)
    this.token = this.$route.query.token
    this.managerMId = parseInt(this.$route.query.managerMId)

    if (!this.csId || !this.token || !this.managerMId) {
      await Swal.fire({
        icon: 'error',
        title: this.$t('錯誤'),
        text: this.$t('無效的存取方式')
      })
      window.location.href = '/'
      return
    }

    // 驗證token並載入排班資料
    await this.loadScheduleDetail()

    this.$nextTick(() => {
      this.syncRowHeights()
      window.addEventListener('resize', this.syncRowHeights)

      // 寬度等於表格寬度
      const name = this.$el.querySelector('.name_wrapper')
      const date = this.$el.querySelector('.date_wrapper')
      const container = this.$el.querySelector('.shiftSchedule_box .container')

      if (!name || !date || !container) return

      const totalWidth = name.offsetWidth + date.offsetWidth + 25

      container.style.maxWidth = totalWidth + 'px'
    })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.closePicker)
    window.removeEventListener('resize', this.syncRowHeights)
  },

  computed: {
    scheduleOpenStatus() {
      const now = new Date()
      const openStart = this.openSchedulingStartTime ? new Date(this.openSchedulingStartTime) : null
      const openEnd = this.openSchedulingEndTime ? new Date(this.openSchedulingEndTime) : null
      if (!openStart || !openEnd) return 'open'
      if (now < openStart) return 'notOpen'
      if (now >= openStart && now <= openEnd) return 'open'
      return 'closed'
    },

    daysInPeriod() {
      if (!this.startDate || !this.endDate) return []

      const days = []
      const start = new Date(this.startDate)
      const end = new Date(this.endDate)

      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        const dateStr = this.formatDate(d)
        const dayNum = d.getDate()
        const weekday = ['日', '一', '二', '三', '四', '五', '六'][d.getDay()]
        const isHoliday = d.getDay() === 0 || d.getDay() === 6

        days.push({ dateStr, day: dayNum, weekday, isHoliday })
      }

      return days
    }
  },

  methods: {

    async loadScheduleDetail() {
      try {
        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaStaffVolunteer/GetScheduleDetailForManager`;
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            csId: this.csId,
            token: this.token,
            managerMId: this.managerMId,
            accountType: 'Employee'
          })
        })

        const result = await response.json()
        if (!result.ok) {
          await Swal.fire({
            icon: 'error',
            title: this.$t('載入失敗'),
            text: result.message || this.$t('載入失敗')
          })
          window.location.href = '/'
          return
        }

        // 設定基本資料
        this.scheduleName = result.scheduling.scheduleName
        this.startDate = result.scheduling.startDate
        this.endDate = result.scheduling.endDate
        this.minRestDays = result.scheduling.minRestDays || 0
        this.minRegularDaysOff = result.scheduling.minRegularDaysOff || 0
        this.openSchedulingStartTime = result.scheduling.openSchedulingStartTime || null
        this.openSchedulingEndTime = result.scheduling.openSchedulingEndTime || null

        // 建立使用者列表
        this.users = result.allStaffSchedules.map(staff => ({
          csvId: staff.csvId,
          name: staff.name
        }))

        // 載入所有員工的排班記錄
        result.allStaffSchedules.forEach(staff => {
          staff.schedules.forEach(schedule => {
            const formattedDate = this.formatDate(schedule.scheduleDate)
            const key = `${staff.csvId}_${formattedDate}`
            this.$set(this.schedules, key, schedule.shiftType)
          })
        })

      } catch (error) {
        console.error('載入排班資料失敗:', error)
        await Swal.fire({
          icon: 'error',
          title: this.$t('載入失敗'),
          text: this.$t('載入排班資料失敗，請稍後再試')
        })
        window.location.href = '/'
      }
    },

    async saveSchedule() {
      if (this.scheduleOpenStatus !== 'open') return

      const result = await Swal.fire({
        icon: 'question',
        title: this.$t('確認儲存'),
        text: this.$t('確定要儲存所有員工的排班嗎？'),
        showCancelButton: true,
        confirmButtonText: this.$t('確定儲存'),
        cancelButtonText: this.$t('取消'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
      })
      
      if (!result.isConfirmed) {
        return
      }

      try {
        // 收集所有員工的排班記錄並分別儲存
        for (const user of this.users) {
          const userSchedules = []
          Object.keys(this.schedules).forEach(key => {
            const [csvId, date] = key.split('_')
            if (parseInt(csvId) === user.csvId) {
              const shiftType = this.schedules[key]
              // 儲存非可上班日的班別
              if (shiftType !== 'workday') {
                userSchedules.push({
                  scheduleDate: date,
                  shiftType: shiftType
                })
              }
            }
          })

          const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaStaffVolunteer/SaveScheduleForManager`;
          const response = await fetch(apiUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              csId: this.csId,
              csvId: user.csvId,
              token: this.token,
              managerMId: this.managerMId,
              schedules: userSchedules,
              isSubmitted: true // 管理者直接標記為已送出
            })
          })

          const saveResult = await response.json()
          if (!saveResult.ok) {
            await Swal.fire({
              icon: 'error',
              title: this.$t('儲存失敗'),
              text: `${this.$t('儲存')} ${user.name} ${this.$t('的排班失敗')}: ${saveResult.message}`
            })
            return
          }
        }

        await Swal.fire({
          icon: 'success',
          title: this.$t('儲存成功'),
          text: this.$t('所有員工的排班已成功儲存'),
          showConfirmButton: true,
          confirmButtonText: this.$t('確定')
        })

      } catch (error) {
        console.error('儲存失敗:', error)
        await Swal.fire({
          icon: 'error',
          title: this.$t('儲存失敗'),
          text: this.$t('儲存失敗，請稍後再試')
        })
      }
    },

    // 班別 picker
    openPicker(userId, day, event) {
      if (this.scheduleOpenStatus !== 'open') return
      this.picker = { visible: true, userId, day, x: event.clientX, y: event.clientY }
    },
    selectShift(shiftId) {
      const key = `${this.picker.userId}_${this.picker.day}`
      this.$set(this.schedules, key, shiftId)
      this.picker.visible = false
      this.$nextTick(this.syncRowHeights)
    },
    getShiftImg(userId, day) {
      const key = `${userId}_${day}`
      const shiftId = this.schedules[key]
      const opt = this.shiftOptions.find(o => o.id === shiftId)
      return opt ? opt.img : null
    },
    formatDate(date) {
      const d = typeof date === 'string' ? new Date(date) : date
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },

    closePicker() { this.picker.visible = false },

    // 同步左右表格行高
    syncRowHeights() {
      this.$nextTick(() => {
        const nameRows = this.$el.querySelectorAll('.name_table tbody tr')
        const scheduleRows = this.$el.querySelectorAll('.schedule_table tbody tr')
        nameRows.forEach((row, i) => {
          const scheduleRow = scheduleRows[i]
          if (scheduleRow) {
            const maxHeight = Math.max(row.offsetHeight, scheduleRow.offsetHeight)
            row.style.height = maxHeight + 'px'
            scheduleRow.style.height = maxHeight + 'px'
          }
        })
        const nameHead = this.$el.querySelector('.name_table thead tr')
        const scheduleHead = this.$el.querySelector('.schedule_table thead tr')
        if (nameHead && scheduleHead) {
          const maxHeadHeight = Math.max(nameHead.offsetHeight, scheduleHead.offsetHeight)
          nameHead.style.height = maxHeadHeight + 'px'
          scheduleHead.style.height = maxHeadHeight + 'px'
        }
      })
    },
  }
}

</script>

<style scoped>
.schedule_status_notice {
  display: inline-block;
  padding: 6px 18px;
  border-radius: 4px;
  font-size: 15px;
  font-weight: 600;
  margin-top: 10px;
}

.notice_warning {
  background-color: #ffc107;
  color: #333;
}

.notice_closed {
  background-color: #dc3545;
  color: white;
}

.date_btn_no_edit {
  cursor: not-allowed;
  opacity: 0.7;
}

.send_btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: #9e9e9e;
}
</style>
